import { GET_FURNITURE_TYPES_SUCCESS } from "../actionTypes";

const initialState = [];

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_FURNITURE_TYPES_SUCCESS: {
      const furnitureTypes = action.payload;

      if (!furnitureTypes){
        return [...state];
      }

      return [
        ...state,
        ...furnitureTypes
      ]
    }
    default:
      return state;
  }
}
